/** Map Deluxe email field names onto both the new and legacy API keys. */
export function buildDeluxeSavePayload(form = {}) {
  const clientId = String(form.clientId || '').trim();
  const clientSecret = String(form.clientSecret || '').trim();
  const accessToken = String(form.accessToken || form.partnerToken || '').trim();
  const signatureKey = String(form.signatureKey || '').trim();
  const clientIdSandbox = String(form.clientIdSandbox || '').trim();
  const clientSecretSandbox = String(form.clientSecretSandbox || '').trim();
  const accessTokenSandbox = String(form.accessTokenSandbox || form.partnerTokenSandbox || '').trim();
  const signatureKeySandbox = String(form.signatureKeySandbox || '').trim();

  return {
    clientId,
    clientSecret,
    accessToken,
    signatureKey,
    partnerToken: accessToken,
    hpfToken: accessToken,
    clientIdSandbox,
    clientSecretSandbox,
    accessTokenSandbox,
    signatureKeySandbox,
    partnerTokenSandbox: accessTokenSandbox,
    hpfTokenSandbox: accessTokenSandbox,
  };
}
